import React, { useState } from 'react';

const RechargePopup = () => {
  const [isOpen, setIsOpen] = useState(true);

  const handleRecharge = () => {
    window.location.href = '/dashboard/transaction-payment';
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    isOpen && (
      <div style={styles.overlay}>
        <div style={styles.popup}>
          <button style={styles.closeButton} onClick={handleClose}>
            &times;
          </button>
          <h2 style={styles.heading}>Recharge Required</h2>
          <p style={styles.message}>
             Your Startup Plan includes access to our API services. To fully unlock the benefits of our campaign services, please complete a minimum recharge of ₹1,000. 
          </p>
          <button style={styles.button} onClick={handleRecharge}>
            RECHARGE NOW →
          </button>
        </div>
      </div>
    )
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1200,
  },
  popup: {
    position: 'relative',
    background: 'white',
    borderRadius: '12px',
    padding: '30px 40px',
    textAlign: 'center',
    boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
    width: '400px',
    Height: '500px'
  },
  closeButton: {
    position: 'absolute',
    top: '12px',
    right: '15px',
    background: 'transparent',
    border: 'none',
    fontSize: '20px',
    fontWeight: 'bold',
    cursor: 'pointer',
    color: '#666',
  },
  heading: {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '20px',
    letterSpacing: '1px',
    color: '#333',
  },
  message: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '25px',
  },
  button: {
    background: '#3399FF',
    border: 'none',
    color: '#fff',
    padding: '12px 25px',
    borderRadius: '25px',
    fontWeight: 'bold',
    cursor: 'pointer',
    boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
  },
};

export default RechargePopup;
